import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/auth";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import SuperAdminHome from "@/pages/superadmin/SuperAdminHome";
import SubaccountNew from "@/pages/superadmin/SubaccountNew";
import SubaccountDetail from "@/pages/superadmin/SubaccountDetail";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import DashboardOverview from "@/pages/dashboard/DashboardOverview";
import VolunteersPage from "@/pages/dashboard/VolunteersPage";
import ModuloViabilidad from "@/pages/dashboard/ModuloViabilidad";
import ModuloEstructura from "@/pages/dashboard/ModuloEstructura";
import CoveragePage from "@/pages/dashboard/CoveragePage";
import UsersPage from "@/pages/dashboard/UsersPage";
import LinksPage from "@/pages/dashboard/LinksPage";
import LinkApprovalsPage from "@/pages/dashboard/LinkApprovalsPage";
import CasillasPage from "@/pages/dashboard/CasillasPage";
import RecruitPage from "@/pages/public/RecruitPage";
import NoctuaShell from "@/pages/noctua/NoctuaShell";
import MapaPage from "@/pages/noctua/MapaPage";
import LecturaPage from "@/pages/noctua/LecturaPage";
import InteligenciaPage from "@/pages/noctua/InteligenciaPage";
import EscenariosPage from "@/pages/noctua/EscenariosPage";
import DatosPage from "@/pages/noctua/DatosPage";
import "@/App.css";

function RoleRoute({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role))
    return <Navigate to="/dashboard" replace />;
  return children;
}

function HomeRedirect() {
  const { user } = useAuth();
  if (!user) return <Landing />;
  if (user.role === "super_admin") return <Navigate to="/super-admin" replace />;
  return <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
        <Route path="/" element={<HomeRedirect />} />
        <Route path="/login" element={<Login />} />
        <Route path="/r/:code" element={<RecruitPage />} />

        {/* Super Admin */}
        <Route
          path="/super-admin"
          element={
            <RoleRoute roles={["super_admin"]}>
              <SuperAdminHome />
            </RoleRoute>
          }
        />
        <Route
          path="/super-admin/subaccounts/new"
          element={
            <RoleRoute roles={["super_admin"]}>
              <SubaccountNew />
            </RoleRoute>
          }
        />
        <Route
          path="/super-admin/subaccounts/:id"
          element={
            <RoleRoute roles={["super_admin"]}>
              <SubaccountDetail />
            </RoleRoute>
          }
        />

        {/* Admin / Coordinators */}
        <Route
          path="/dashboard"
          element={
            <RoleRoute>
              <DashboardLayout />
            </RoleRoute>
          }
        >
          <Route index element={<DashboardOverview />} />
          <Route path="volunteers" element={<VolunteersPage />} />
          <Route path="viabilidad" element={<ModuloViabilidad />} />
          <Route path="estructura" element={<ModuloEstructura />} />
          <Route path="casillas" element={<CasillasPage />} />
          <Route path="coverage" element={<CoveragePage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="links" element={<LinksPage />} />
          <Route path="links/approvals" element={<LinkApprovalsPage />} />
        </Route>

        {/* NOCTUA - Electoral Intelligence (super_admin only) */}
        <Route
          path="/noctua"
          element={
            <RoleRoute roles={["super_admin"]}>
              <NoctuaShell />
            </RoleRoute>
          }
        >
          <Route index element={<Navigate to="/noctua/mapa" replace />} />
          <Route path="mapa" element={<MapaPage />} />
          <Route path="lectura" element={<LecturaPage />} />
          <Route path="inteligencia" element={<InteligenciaPage />} />
          <Route path="escenarios" element={<EscenariosPage />} />
          <Route path="datos" element={<DatosPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
